<div mat-dialog-title class="dialog-header" style="position:relative;text-align:left">
  Login Assistance Information
  <a href="/portal/ui/help" target="_blank" class="reference" style="position:absolute;right:0;top:50%;transform:translateY(-50%);font-size:0.8rem;white-space:nowrap">Visit Login Assistance page</a>
</div>
<mat-dialog-content class="container">
  <div class="row">
    <div class="col">
      If you need assistance to log in, select and copy the information below and send it to the help desk:
    </div>
  </div>
  <div class="row" *ngIf="lastTransaction">
    <div class="col">
      <strong>Timestamp:</strong> {{lastTransaction}}
    </div>
  </div>
  <div class="row" *ngIf="clientTxId">
    <div class="col">
      <strong>Client Transaction:</strong> {{clientTxId}}
    </div>
  </div>
  <div class="row" *ngIf="userName">
    <div class="col">
      <strong>User:</strong> {{userName}}
    </div>
  </div>
  <div class="row" *ngIf="lastErrorResponse">
    <div class="col">
      <strong>Response Status:</strong> {{lastErrorResponse.status}}
    </div>
  </div>
  <hr class="my-2" *ngIf="lastErrorResponse?.body">
  <div class="row" *ngIf="lastErrorResponse?.body">
    <div class="col">
      <strong>Response Body:</strong>
      <div *ngIf="isHtmlResponse" class="mt-1" style="position:relative;overflow:hidden;height:260px;border:1px solid #ddd;border-radius:4px;">
        <div style="position:absolute;top:0;left:0;right:0;bottom:0;overflow-y:auto;" [innerHTML]="safeHtmlBody"></div>
      </div>
      <div *ngIf="!isHtmlResponse && simplifiedErrorFields" class="mt-1">
        <div *ngFor="let field of simplifiedErrorFields">
          <strong>{{field.label}}:</strong> {{field.value}}
        </div>
      </div>
      <pre *ngIf="!isHtmlResponse && !simplifiedErrorFields" class="mt-1" style="white-space:pre-wrap;word-break:break-word;font-family:inherit">{{lastErrorResponse.body | json}}</pre>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <a href="/portal/ui/help" target="_blank" class="reference">Visit Login Assistance page for more information and support contacts.</a>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="container gx-0">
    <div class="row g-2">
      <div class="col px-0">
        <button mat-button name="Copy Button" class="primary-btn w-100" (click)="onCopyToClipboard()">
          <span *ngIf="!isCopied">Copy to Clipboard</span>
          <span *ngIf="isCopied">Copied!</span>
        </button>
      </div>
      <div class="col px-0">
        <button mat-button name="Close Button" class="secondary-btn w-100" cdkFocusInitial (click)="onClose()">Close</button>
      </div>
    </div>
  </div>
</mat-dialog-actions>
